// Logo variants — all assets cropped tight to remove canvas padding.
// `dark`      → black-bg version (icon + TAXINPHO wordmark, horizontal) — use on LIGHT surfaces
// `horizontal`→ horizontal white wordmark+icon (w3)                     — use on DARK surfaces (sidebar)
// `stacked`   → stacked cyan icon + TAXINPHO white text                 — use on DARK hero (login)
const SRC = {
  dark: "/taxinpho-logo.png",
  horizontal: "/taxinpho-w3.png",
  stacked: "/taxinpho-w1.png",
};

export default function Logo({ className = "h-8", variant = "dark" }) {
  return (
    <img
      src={SRC[variant] || SRC.dark}
      alt="TAXINPHO"
      className={className}
      style={{ objectFit: "contain" }}
      data-testid="taxinpho-logo"
    />
  );
}
